






















import mixins from 'vue-typed-mixins';
export default mixins().extend({
  computed: {
    attrs(): any {
      return {
        ...this.$attrs,
      };
    },
    listeners(): any {
      return {
        ...this.$listeners,
      };
    },
  },
  data(): {
    message?: string;
    callback?: any;
  } {
    return {
      message: undefined,
      callback: undefined,
    };
  },
  methods: {
    async accept(resolve: any) {
      if (this.callback) {
        try {
          (this.$refs.alert as any).hide('confirm');
          await this.callback();
          this.message = undefined;
          this.callback = undefined;
          resolve(true);
        } catch (error) {
          (this.$refs.alert as any).show('confirm', {
            type: 'error',
            messages: this.$handleAPIError(error),
          });
        }
      } else {
        this.message = undefined;
        this.callback = undefined;
        resolve(true);
      }
    },
    decline(resolve: any) {
      this.message = undefined;
      this.callback = undefined;
      resolve(false);
    },
    open(message: string, callback?: Function) {
      this.message = message;
      this.callback = callback;
      return (this.$refs.modal as any).open();
    },
  },
});
